module.exports = {
  'Credit Card Offer': 'Oferta de Tarjeta de Crédito',
  'Loading': 'Cargando',
};
